import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ChoferEAD;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Valida un ChoferEAD
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = { };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class ChoferEADFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    onChange = (x: null | number) => {
        debugger;
        this.state
        this.setState({ folio: x });
    }

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Text = getField(kea.Text);
        const Sucursal = getField(selectores.Sucursal);

        debugger;
        let  ccc = value
        const CpSatMunicipioSelector = getField(selectores.CpSatMunicipioSelector);


        const validarIdMunicipio = value.IdCpSatMunicipio === undefined || value.IdCpSatMunicipio == null? 0 : value.IdCpSatMunicipio
        const CpSatLocalidadByMunicipioSelector = getField(selectores.CpSatLocalidadByMunicipioSelector ( validarIdMunicipio ));
        const CpSatColoniaByMunicipioSelector = getField(selectores.CpSatColoniaByMunicipioSelector ( validarIdMunicipio ));


        const CpSatLocalidadSelector = getField(selectores.CpSatLocalidadSelector);
        const CpSatColoniaSelector = getField(selectores.CpSatColoniaSelector);

        return (
            <div>
                <kea.Title titulo="Chofer EAD" onRegresar={() => history.go("/catalogos/ChoferEAD")} />
                {kea.autogrid(3, [
                    <Text field="Nombre" />,
                    <Sucursal field="IdSucursal" label="Sucursal" />,
                    <Text field="RFC" />,
                    <Text field="NumeroLicencia" label="Numero de licencia" />,

                ])}
                {kea.autogrid(4, [
                    <Text field="DireccionCalle" label="Calle" />,
                    <Text field="DireccionNumExt" label="Numero exterior" />,
                    <Text field="DireccionNumInt" label="Numero interior" />,

                    <CpSatMunicipioSelector field="IdCpSatMunicipio" label="Municipio Sat" />,
                    <CpSatLocalidadByMunicipioSelector field="IdCpSatLocalidad" label="Localidad Sat" />,
                    <CpSatColoniaByMunicipioSelector field="IdCpSatColonia" label="Colonia Sat" />,
                    
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const ChoferEADForm = componentToRx(ChoferEADFormNoRx);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/choferEAD/edit/form.tsx